/**
 * Created by Rodrigo Quesada on 23/01/17.
 */
import {AddressModel} from './addresspicker.component';
import {Injectable} from '@angular/core';

const addressTypeToModel: Object = {
    street_number: {
        modelProperty: 'streetNumber',
        format: 'long_name'
    },
    route: {
        modelProperty: 'address1',
        format: 'long_name'
    },
    postal_code: {
        modelProperty: 'postalCode',
        format: 'short_name'
    },
    locality: {
        modelProperty: 'city',
        format: 'long_name'
    },
    administrative_area_level_1: {
        modelProperty: 'stateOrProvince',
        format: 'long_name'
    },
    country: {
        modelProperty: 'country',
        format: 'long_name'
    }
};

@Injectable()
export class AddressMapper {

    map(placeResult: google.maps.places.PlaceResult): AddressModel {
        let model = new AddressModel();

        if (placeResult.address_components) {
            // Fill the model with the place information
            for (let i = 0; i < placeResult.address_components.length; i++) {
                let addressType = placeResult.address_components[i].types[0];
                let addressTypeInfo = addressTypeToModel[addressType];
                if (addressTypeInfo) {
                    let val = placeResult.address_components[i][addressTypeInfo.format];
                    model[addressTypeInfo.modelProperty] = val;
                }
            }
        }

        if ((model as any).streetNumber) {
            model.address1 = `${(model as any).streetNumber} ${model.address1}`;
            delete (model as any).streetNumber;
        }

        return model;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/addresspicker/address-mapper.service.ts